import React from 'react'

import { Form, Select, DatePicker, TimePicker, Input, InputNumber, Checkbox, Button } from 'antd'
import moment from 'moment'
import data from './data'

const Option = Select.Option


class TransformEditor extends React.Component {

  constructor(props, ...args) {
    super(props, ...args)
    const { id } = props.match.params
    const record = data.find(x => x.key === id) || {}
    this.state = {
      sourceField: record.sourceField || '',
      sourceDataType: record.sourceDataType || '',
      sourceDataFormat: record.sourceDataFormat || '',
      targetField: record.targetField || '',
      targetDataFormat: record.targetDataFormat || '',
      sampleInput: record.sampleInput || '',
      transformedOutput: record.transformedOutput || '',
      location: '',
      submitted: false,
    }
    if(this.state.sourceDataFormat)
      this.state.transformedOutput = moment(this.state.sampleInput, this.state.sourceDataFormat, true).format(this.state.targetDataFormat)

    navigator.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {
      this.setState({ location: `${latitude}, ${longitude}` })
    })

    this.onChange = key => value => {
      if(typeof value === 'object') value = value.target.value
      let transformedOutput = this.state.transformedOutput
      if(key === 'sampleInput' && /date|time/i.test(this.state.sourceDataType)) {
        transformedOutput = moment(value, this.state.sourceDataFormat, true).format(this.state.targetDataFormat)
      }
      this.setState({ [key]: value, transformedOutput })
    }
  }

  render() {
    const formItemLayout = {
      labelCol: { xs: { span: 4 } },
      wrapperCol: { xs: { span: 8 } },
    }
    const tailFormItemLayout = {
      labelCol: { xs: { span: 4 } },
      wrapperCol: { xs: { span: 8, offset: 4 } },
    }

    if(this.state.submitted) return (
      <div>
        <h2>STOP data successfully uploaded.</h2>
      <p><a href="/ingest" onClick={() => this.setState({ submitted: false })}>Enter another.</a></p>
      </div>
    )

    return (
      <div>
        <h2>Enter STOP Data</h2>
        <Form onSubmit={evt => { evt.preventDefault(); this.setState({ submitted: true }) }}>

          <Form.Item
            {...formItemLayout}
            label={<b>Agency</b>}>
            <Input disabled value={'Exampleville PD'} />
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="Stop date & time">
            <DatePicker />{' '}
            <TimePicker />
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="Stop coordinates">
            <Input disabled value={this.state.location} />
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="Race of individual stopped">
            <Select defaultValue="U">
              <Option value="U">Unknown</Option>
              <Option value="I">American Indian or Alaskan Native</Option>
              <Option value="A">Asian or Pacific Islander</Option>
              <Option value="B">Black</Option>
              <Option value="W">White</Option>
            </Select>
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="Age of individual stopped">
            <InputNumber min={1} max={120} defaultValue={25} />
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="Sex of individual stopped">
            <Select defaultValue="X">
              <Option value="X">X</Option>
              <Option value="M">Male</Option>
              <Option value="F">Female</Option>
            </Select>
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="Search conducted?">
            <Checkbox checked={this.state.searchConducted} onClick={() => this.setState(s => ({ searchConducted: !s.searchConducted }))} />
          </Form.Item>

          {this.state.searchConducted &&
            <Form.Item
              {...formItemLayout}
              label="Type of search conducted">
              <Input />
            </Form.Item>
          }

          <Form.Item {...tailFormItemLayout}>
            <p>...</p>
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Submit</Button>
          </Form.Item>

        </Form>
      </div>
    )
  }
}

export default TransformEditor



// WEBPACK FOOTER //
// ./src/IngestForm.js